// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__335eM","rightAdornment":"Header_rightAdornment__2IBWm"};